import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


const HomeTrainerSplit = () => {
    return (
            <div className="rn-splite-style">
                <div className="split-wrapper">
                        <div className="row no-gutters radius-10 align-items-center">
                            
                            <div className="col-lg-12 col-xl-6 col-12">
                                <div className="split-inner">
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <h4 className="title">Training Outcomes</h4>
                                    </ScrollAnimation>
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <p className="description"></p>
                                    </ScrollAnimation>

                                    
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <ol className="" style={{color:"white"}}>
                                            {/* <li>✅ what an individual can expect after taking training from PWU.</li> */}
                                            <li> Build a personalized 12-month action plan to grow your income by 2X–5X.</li>
                                            <li> Launch 1–2 new income streams within 90 days using our step-by-step systems</li>
                                            <li> Improve your sales closing rate by 30–50% through practical sales training.</li>
                                            <li> Reduce financial stress by 70% by mastering money management and wealth psychology.</li>
                                            <li> Gain clarity and confidence to make smarter life, business, and investment decisions within 30 days.</li>
                                        </ol>
                                    </ScrollAnimation>
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <div className="view-more-button mt--35">
                                            <Link className="btn-default" to="/trainer">LEARN MORE</Link>
                                        </div>
                                    </ScrollAnimation>
                                </div>
                        </div>
                        <div className="col-lg-12 col-xl-6 col-12">
                                <div className="thumbnail image-left-content">
                                    <img src="./images/training-pwu.jpg" alt="split Images" />
                                </div>
                            </div>
                    </div>
                </div>
            </div>
    )
}

export default HomeTrainerSplit
